/**
 * @(#)2019/10/12.
 * Search 搜索框
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Utils from "../../utils";
import Basics from "./Basics";
import { Input } from "antd";
import { YxComponent, Connection } from "../YxComponent";
import { IYxInputPropTypes } from "./IpropType/basePropType";
import PropTypes from "prop-types";

/*
 * @param onSearch {function} 搜索触发时的回调
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */
//默认props
let defaul = () => {
  return {
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型 default dark
    },
    children: <Input.Search />, //子节点
    onSearch: () => {},
    inputParam: {},
  };
};
@Connection(defaul)
class YxSearch extends YxComponent {
  productionHtml() {
    let tmpProps = { ...this.props };
    tmpProps.inputParam.onSearch = tmpProps.onSearch;
    let classParam = {
      yx_yxSearch_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxSearch_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );
    let html = Basics.html(this.props);
    return html;
  }
  render() {
    return this.productionHtml();
  }
}

YxSearch.propTypes = {
  ...IYxInputPropTypes,
  onSearch: PropTypes.func,
};
YxSearch.defaultProps = defaul();
export default YxSearch;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Search.js